import * as React from 'react';
import * as HmiFiles from '../../hmilib/hmifiles';

interface iLeftMenu {
    display: string;
    setDisplay: any;
}

const LeftMenu = (props: iLeftMenu) => {
    const [loadstate, setLoadState] = React.useState(false);

    React.useEffect(() => {
        LoadLeftMenu();

        return function clear() {};
    }, [loadstate]);

    let memoryId: number = 0;

    let ShowMenu = function (id: number) {
        id = id === undefined ? memoryId : id;

        const activeMenu = document.querySelector('.open-menu') as HTMLElement | null;

        if (activeMenu) {
            if (activeMenu.classList.contains('active')) {
                activeMenu.classList.remove('active');
            } else {
                activeMenu.classList.add('active');
            }
        }

        let menupole = document.getElementById('menu-pole' + id);
        if (menupole) {
            let opac = menupole.style.opacity;
            if (opac === '0' || opac === '') {
                var menupoleclass = document.getElementsByClassName('menu-pole');
                for (var objop = 0; objop < menupoleclass.length; objop++) {
                    let menupoleclassind = menupoleclass[objop];
                    if (menupoleclassind != null) {
                        if (menupoleclassind instanceof HTMLElement) {
                            menupoleclassind.style.opacity = '0';
                            menupoleclassind.style.display = 'none';
                        }
                    }
                }

                menupole.style.opacity = '1';
                menupole.style.display = 'block';

                // activeMenu = document.querySelector("[onclick*='ShowMenu(" + id + ")']");
                // if (activeMenu) activeMenu.className = activeMenu.className + ' active';
            } else {
                menupole.style.opacity = '0';
                menupole.style.display = 'none';
            }

            //document.getElementById("mnemo").style.width = "calc(100% - " + document.getElementById("menu").offsetWidth + "px - " + menupole.offsetWidth + "px)";

            memoryId = id;
        }
    };

    let LoadLeftMenu = function () {
        var onefram = window.parent.document.getElementById('mnemo');

        var funcOK = function (state: any) {
            //mnemo.style.height = mnemo.getElementsByTagName("svg")[0].viewBox.baseVal.height + "px";
        };

        var xhr = new XMLHttpRequest();
        xhr.open('GET', '/ixyber/vision/UserFiles/config/settings.xml', true);
        xhr.setRequestHeader('Content-type', 'application/xml');
        xhr.onreadystatechange = function () {
            // Ждём ответа от сервера
            if (xhr.readyState === 4) {
                // Ответ пришёл
                if (xhr.status === 200 && this.responseXML != null) {
                    // Сервер вернул код 200 (что хорошо)
                    let settings = this.responseXML;
                    var menu = settings.querySelectorAll('menupole menu');
                    if (menu.length !== 0) {
                        for (var i = 0; i < menu.length; i++) {
                            var accesButton = true;
                            var operacces = menu[i].querySelector('operacces');
                            if (operacces !== null) {
                                accesButton =
                                    operacces.innerHTML.toLowerCase() === 'false' &&
                                    window.GetParam('SYSTEM.USERROLEID').Value === 1
                                        ? false
                                        : true;
                            }
                            if (accesButton) {
                                var openMenu = document.createElement('div');
                                openMenu.className = 'open-menu';
                                let menuObj = document.getElementById('menu');
                                if (menuObj) menuObj.appendChild(openMenu);
                                openMenu.addEventListener('click', () => ShowMenu(i));
                                openMenu.style.top = 95 * i + 'px';
                                let nameDiv = menu[i].querySelector('name');
                                if (nameDiv != null) {
                                    openMenu.innerHTML = nameDiv.innerHTML;
                                }

                                var menuPole = document.createElement('div'); //iframe
                                menuPole.id = 'menu-pole' + i;
                                menuPole.className = 'menu-pole';
                                //document.getElementById("pole").insertBefore(menupole, document.getElementById("mnemo"));

                                let menulable = document.getElementById('menulable');
                                if (menulable) menulable.appendChild(menuPole);

                                let imagediv = menu[i].querySelector('image');
                                if (imagediv != null) {
                                    HmiFiles.OpenMnemo(imagediv.innerHTML, 0, null, menuPole, funcOK);
                                }
                            }
                        }
                    } else {
                        var openMenu = document.createElement('div');
                        openMenu.className = 'open-menu';
                        let menuDiv = document.getElementById('menu');
                        if (menuDiv != null) {
                            menuDiv.appendChild(openMenu);
                            openMenu.addEventListener('click', () => ShowMenu(0));
                            openMenu.style.top = 95 * 0 + 'px';
                            openMenu.innerHTML = 'МЕНЮ';

                            var menuPole = document.createElement('div'); //iframe
                            menuPole.id = 'menu-pole' + 0;
                            menuPole.className = 'menu-pole';
                            //document.getElementById("pole").insertBefore(menupole, document.getElementById("mnemo"));

                            let menuLabel = document.getElementById('menulable');
                            if (menuLabel) menuLabel.appendChild(menuPole);

                            HmiFiles.OpenMnemo('MENU-POLE', 0, null, menuPole, funcOK);
                        }
                    }

                    //returnfun(xhr.responseXML);
                } else {
                    var openMenu = document.createElement('div');
                    openMenu.className = 'open-menu';

                    let menuElem = document.getElementById('menu');
                    if (menuElem) {
                        if (!menuElem.querySelector('div')) {
                            menuElem.appendChild(openMenu);

                            openMenu.addEventListener('click', () => ShowMenu(0));

                            openMenu.style.top = 95 * 0 + 'px';
                            openMenu.innerHTML = 'MENU';

                            var menuPole = document.createElement('div'); //iframe
                            menuPole.id = 'menu-pole' + 0;
                            menuPole.className = 'menu-pole';
                            //document.getElementById("pole").insertBefore(menupole, document.getElementById("mnemo"));
                            let menuLabel = document.getElementById('menulable');
                            if (menuLabel) menuLabel.appendChild(menuPole);

                            HmiFiles.OpenMnemo('MENU-POLE', 0, null, menuPole, funcOK);
                        }
                    }
                }

                ShowMenu(0);
            }
        };

        xhr.send(null);
    };

    return (
        <nav id="menuleft" style={{ display: props.display }}>
            <div
                id="closemenu"
                className="leftmenu"
                title="Свернуть"
                onClick={() => {
                    props.setDisplay('none');
                }}>
                <svg width="9" height="9" viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.828207 4.2034L4.09301 0.87924C4.30861 0.65972 4.65621 0.65972 4.87181 0.87924C5.08741 1.09876 5.08741 1.45268 4.87181 1.6722L1.99421 4.59988L4.87181 7.5298C5.08741 7.74932 5.08741 8.10324 4.87181 8.32276C4.76401 8.43252 4.62321 8.48628 4.48241 8.48628C4.34161 8.48628 4.20081 8.43252 4.09301 8.32276L0.828207 4.9986C0.612607 4.77684 0.612607 4.42292 0.828207 4.2034Z"></path>
                    <path d="M4.12819 4.2034L7.39519 0.87924C7.61079 0.65972 7.95839 0.65972 8.17399 0.87924C8.38959 1.09876 8.38959 1.45268 8.17399 1.6722L5.29419 4.59988L8.17179 7.5298C8.38739 7.74932 8.38739 8.10324 8.17179 8.32276C8.06399 8.43252 7.92319 8.48628 7.78239 8.48628C7.64159 8.48628 7.50079 8.43252 7.39299 8.32276L4.12819 4.9986C3.91259 4.77684 3.91259 4.42292 4.12819 4.2034Z"></path>
                </svg>
            </div>

            <div
                id="homebut"
                style={{ left: '30px', top: '5px', float: 'left' }}
                className="leftmenu"
                onClick={() => {
                    window.location.href = '/';
                }}
                title="Главная">
                <svg className="svg_icon" width="16" height="19" viewBox="0 0 16 19" xmlns="http://www.w3.org/2000/svg">
                    <g>
                        <path d="M11.889 7.19465C11.8431 7.31368 11.7623 7.41606 11.6572 7.48839C11.5521 7.56071 11.4276 7.59961 11.3 7.59999H10.0334V13.3C10.0334 13.468 9.96663 13.629 9.84785 13.7478C9.72908 13.8666 9.56799 13.9333 9.40002 13.9333H7.50002C7.33205 13.9333 7.17096 13.8666 7.05218 13.7478C6.93341 13.629 6.86668 13.468 6.86668 13.3V10.8427C6.88037 10.5302 6.78194 10.2232 6.58916 9.97702C6.39637 9.73081 6.12192 9.56162 5.81535 9.49999C5.63193 9.46832 5.44378 9.47748 5.2643 9.52679C5.08481 9.5761 4.9184 9.66437 4.7769 9.78531C4.63541 9.90624 4.52231 10.0569 4.44564 10.2265C4.36898 10.3961 4.33064 10.5805 4.33335 10.7667V13.3C4.33335 13.468 4.26663 13.629 4.14785 13.7478C4.02908 13.8666 3.86799 13.9333 3.70002 13.9333H1.80002C1.63205 13.9333 1.47096 13.8666 1.35218 13.7478C1.23341 13.629 1.16668 13.468 1.16668 13.3V7.59999H-0.0999816C-0.227561 7.59961 -0.352052 7.56071 -0.45715 7.48839C-0.562249 7.41606 -0.643053 7.31368 -0.688982 7.19465C-0.735674 7.07403 -0.744316 6.94201 -0.713745 6.81633C-0.683175 6.69066 -0.614859 6.57735 -0.517982 6.49165L5.18202 1.42499C5.29759 1.32345 5.44618 1.26746 5.60002 1.26746C5.75386 1.26746 5.90244 1.32345 6.01802 1.42499L11.718 6.49165C11.8149 6.57735 11.8832 6.69066 11.9138 6.81633C11.9444 6.94201 11.9357 7.07403 11.889 7.19465Z"></path>
                    </g>
                </svg>
            </div>

            <div
                id="playmodel"
                style={{ left: '50px', top: '6px', width: '13px', position: 'relative', float: 'left' }}
                className="leftmenu statemodel">
                <svg
                    style={{ pointerEvents: 'all' }}
                    xlinkTitle="Запустить расчет модели"
                    className="svg_icon runmodelhi runmodel"
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 41.999 41.999"
                    xmlSpace="preserve">
                    <path
                        d="M36.068,20.176l-29-20C6.761-0.035,6.363-0.057,6.035,0.114C5.706,0.287,5.5,0.627,5.5,0.999v40
	                    c0,0.372,0.206,0.713,0.535,0.886c0.146,0.076,0.306,0.114,0.465,0.114c0.199,0,0.397-0.06,0.568-0.177l29-20
	                    c0.271-0.187,0.432-0.494,0.432-0.823S36.338,20.363,36.068,20.176z"></path>

                    <title>Запустить расчет модели</title>
                </svg>

                <svg
                    style={{ pointerEvents: 'all' }}
                    xlinkTitle="Приостановить расчет модели"
                    className="svg_icon runmodelhi stopmodel runmodelstate"
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 357 357"
                    xmlSpace="preserve">
                    <g>
                        <g id="pause">
                            <path d="M25.5,357h102V0h-102V357z M229.5,0v357h102V0H229.5z"></path>
                        </g>
                        <title>Приостановить расчет модели</title>
                    </g>
                </svg>
            </div>

            <div id="menulable">
                <div id="menu"></div>
            </div>
        </nav>
    );
};

export default LeftMenu;
